import {Component, Input} from '@angular/core';
import {BaseRecordTableItemComponent} from '../../base-record-table-item/base-record-table-item.component';
import {MatDatepicker} from '@angular/material/datepicker';
import {customMonthYearProvider} from "../../../../../locale/providers/custom-month-year.provider";

@Component({
  selector: 'app-month-year-record-table-item',
  standalone: false,
  templateUrl: './month-year-record-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    '../date-record-table-item/date-record-table-item.component.scss',
    './month-year-record-table-item.component.scss'
  ],
  providers: [ ...customMonthYearProvider ]
})
export class MonthYearRecordTableItemComponent extends BaseRecordTableItemComponent {
  @Input({ transform: switchDateFormatsTwo }) override value!: string;
  @Input() isFilter: boolean = false;

  public handleMonthInputChange(date: string, datepicker: MatDatepicker<any>) {
    datepicker.close();

    const newDate = new Date(date);
    this.value = new Intl.DateTimeFormat('ru-RU', {
      month: '2-digit',
      year: 'numeric'
    }).format(newDate).split('.').join('.');

    super.handleValueChange(this.value);
    this.value = this.value.split('.').reverse().join('-') + '-01'
  }

  public formatedDisplayValue(value: string) {
    return value.split('-').reverse().splice(1).join('.');
  }
}

export function switchDateFormatsTwo(value: unknown): string {
  if (!value) { return Date.now().toString(); }
  const valueAsString = '01.' + value as string;
  return valueAsString.split('.').reverse().join('-');
}
